const SCROLLBAR_THUMB_COLOR = 'var(--chakra-colors-border-strong)';

/**
 * Hides the native scrollbar so a floating one can be drawn over the content instead.
 *
 * Why: index.css sets `* { scrollbar-width: thin }`, and Chromium ignores every
 * ::-webkit-scrollbar rule on an element carrying the standard property — so a native bar can
 * be neither styled nor pinned to a known width. A class selector outranks the universal one,
 * so hiding it here works where styling it does not. Pair with Chakra's ScrollArea.
 */
export const hideNativeScrollbarCss = {
	scrollbarWidth: 'none',
	'&::-webkit-scrollbar': { display: 'none' },
} as const;

/**
 * TODO(ui): Revisit the canonical scrollbar approach. These ::-webkit-scrollbar rules are inert
 * in Chromium for the reason described above, so callers reserve a gutter for a bar they cannot
 * style. DropdownMenu and PropertySelectorDesktop have moved to ScrollArea +
 * hideNativeScrollbarCss; FrequencySelector, CustomDateTimePicker and ConnectToBundleSheet still
 * use this. Pick one and retire the other.
 */
export const dropdownScrollbarCss = {
	scrollbarGutter: 'stable',
	'&::-webkit-scrollbar': { width: '8px' },
	'&::-webkit-scrollbar-track': { background: 'transparent' },
	'&::-webkit-scrollbar-thumb': {
		background: SCROLLBAR_THUMB_COLOR,
		border: '2px solid transparent',
		borderRadius: '8px',
		backgroundClip: 'content-box',
	},
	scrollbarWidth: 'thin' as const,
	scrollbarColor: `${SCROLLBAR_THUMB_COLOR} transparent`,
};
